export const diaryDetailSearchFields = {
    INTERNAL_APP_PROPERTY_ID: 'internalAppPropertyId',
    FULL_NAME_SELLER: 'sellerFullName',
    FULL_NAME_BUYER: 'buyerFullName',
    LOCATION: 'propertyLocation',
    DIARY_DATE_FROM: 'conclusionDateFrom',
    DIARY_DATE_TO: 'conclusionDateTo',
}
